import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import { Customer, Loading } from "../../../helpers/shared-interfaces";
import {
  generateNameFromCustomer,
  getCustomerEmailAddress,
  getCustomerPhoneNumber,
} from "../../../helpers/utilities";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  customers: Customer[];
  onCustomerClick: (item: ItemClickProps) => void;
};

export default function Customers({
  customers,
  loading,
  handleRetry,
  onCustomerClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : customers.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        customers.map((customer) => (
          <div
            key={customer.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onCustomerClick({
                id: customer.id,
                type: "customer",
                segment: "customers",
                data: customer,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">
                {generateNameFromCustomer(customer)}
              </div>
              <div className="result-details">
                <MailOutlined /> {getCustomerEmailAddress(customer)} {" / "}
                <PhoneOutlined /> {getCustomerPhoneNumber(customer)}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
